import React, { useState } from 'react';
import { Checkbox, TextField, FormControlLabel } from '@material-ui/core';

import DialogDefault from '../common/DialogDefault';

const ModalCreateGroup = ({
	openCreateGroupModal,
	toggleCreateGroupModal,
	addNewProject,
	toggleLastgangHochladen,
}) => {
	const GRUPPE = 'neue Gruppe';
	const STANDTORT = 'neuer Standort';
	const [inputGroup, setInputGroup] = useState(GRUPPE);
	const [inputLocation, setInputLocation] = useState(STANDTORT);
	const [checkBoxLastGang, setCheckBoxLastgang] = useState(false);

	const resetState = () => {
		setInputGroup(GRUPPE);
		setInputLocation(STANDTORT);
	};

	const submitData = () => {
		toggleCreateGroupModal();
		addNewProject(inputGroup, inputLocation);
		resetState();
		if (checkBoxLastGang) {
			toggleLastgangHochladen();
			setCheckBoxLastgang(false);
		}
	};

	const onChange = () => {
		setCheckBoxLastgang(!checkBoxLastGang);
	};

	return (
		<DialogDefault
			headline="Neue Gruppe erstellen"
			openModal={openCreateGroupModal}
			closeModal={toggleCreateGroupModal}
			confirmButton={submitData}
			confirmButtonText="Erstellen"
		>
			<form autoComplete="off" onSubmit={submitData}>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="Gruppe"
					id="groupInput"
					inputProps={{
						maxLength: 20,
					}}
					onInput={(e) => setInputGroup(e.target.value)}
				/>
				<TextField
					variant="outlined"
					margin="normal"
					required
					fullWidth
					label="Niederlassung"
					id="locationInput"
					inputProps={{
						maxLength: 20,
					}}
					onInput={(e) => setInputLocation(e.target.value)}
				/>
				<FormControlLabel
					control={<Checkbox onChange={onChange} name="checked02" />}
					label="Lastgang hochladen"
				/>
			</form>
		</DialogDefault>
	);
};

export default ModalCreateGroup;
